import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { NatConfiguration } from 'data/natConfiguration/natConfiguration.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenus from 'components/ActionMenus';

interface Props {
  data: NatConfiguration[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedNatConfiguration: NatConfiguration;
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onEdit: () => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onDeleteRow: () => void
}

const NatConfigurationListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedNatConfiguration,
  onSelectItemMenuAction,
  onCreateNew,
  onEdit,
  onRefresh,
  onSelectionChanged,
  onDeleteRow,
}: Props) => {

  const { t } = useTranslation();

  return (
    <div className="grid-container">
      <CommonGrid
        createNewText={t('natConfiguration.create.newNatConfiguration')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        lastUpdatedAt={lastUpdatedAt}
        onActionMenuItemClick={onSelectItemMenuAction}
        onDeleteRow={onDeleteRow}
      >
        <ActionMenus
          name={selectedNatConfiguration?.id as string}
          deleteTitle={t('natConfiguration.deletePopup.title')}
          deleteMessage={t('natConfiguration.deletePopup.message')}
          hasPrivilegesToCreate
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default NatConfigurationListGrid;
